import { render, staticRenderFns } from "./WatchGameOnline.vue?vue&type=template&id=76a870aa&scoped=true&"
import script from "./WatchGameOnline.vue?vue&type=script&lang=js&"
export * from "./WatchGameOnline.vue?vue&type=script&lang=js&"
import style0 from "./WatchGameOnline.vue?vue&type=style&index=0&id=76a870aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a870aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VIcon,VImg})
